import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { TabControl } from '../control';
import { SaveUISettings } from './save-ui-settings';
export const TabLayout = memo(function TabLayout(props) {
    const { children, support_tab_control = true, show_control_button = true, ...rest } = props;
    return (_jsxs(_Fragment, { children: [support_tab_control && (_jsx(TabControl, { show_control_button: show_control_button })), _jsxs(Box, { width: "100%", height: "100%", marginLeft: "auto", marginRight: "auto", children: [_jsx(Box, { px: 2, pb: 2, width: "100%", ...rest, children: children }), _jsx(SaveUISettings, {})] })] }));
});
